<template lang="pug">
v-container
  br
  v-row
    v-card.mx-10(width="100%", elevation="0")
      v-card-title
        h2 {{ $t('tryapis') }}
      v-card-subtitle 
        a(@click="openLink(demoPortal)") {{ $t('godemoportal') }}
      hr
  v-row
    v-card.mx-10(width="100%", elevation="0")
      v-card-title
        H2 {{ $t('knowyourkeysinline') }}
      v-card-subtitle 
        a {{ $t('downloadfulldocument') }}
      hr
      v-progress-linear(
        indeterminate
        color="primary"
        v-if="loading")  
      v-table(v-else)
        br
        //- v-row
        //-   v-col
        //-     v-text {{ $t('names') }}
        //-   v-col
        //-     v-text Nuf
        //-   v-col
        //-     v-text {{ $t('rename') }}
        //-   v-col
        //-     v-text Nufi
        //-   v-col
        //-     v-text {{ $t('activate') }}
        //-   v-col
        //-     v-text {{ $t('cancel') }}

        v-row
          v-col
            v-text {{ $t('startedon') + ' ' + keys.startedOn.substring(0, 10)}}
        v-row
          v-col
            v-text {{ $t('primarykey') }}
          v-col
            v-text {{primary}}
          v-col
            a(@click="showPrimary = !showPrimary") {{ $t(showPrimary ? 'hide' : 'show') }}
            //- a {{ $t('regenerate') }}
          v-col
            v-text
          v-col
            //- a {{ $t('activate') }}
          v-col
            v-text        
        v-row
          v-col
            v-text {{ $t('secondarykey') }}
          v-col
            v-text {{secondary}}
          v-col
            a(@click="showSecondary = !showSecondary") {{ $t(showSecondary ? 'hide' : 'show') }}
            //- a {{ $t('regenerate') }}
          v-col
            v-text
          v-col
            //- a {{ $t('activate') }}
          v-col
            v-text
        br
  br
  v-row
    v-card.mx-10(width="100%", elevation="0")
      v-card-title
        h2 {{ $t('nufipostmaninline') }}
      v-card-subtitle 
        a {{ $t('downloadnufipostman') }}
      hr
</template>
<script>
import link from '@/mixins/link';
export default {
  mixins: [link],
  data() {
    return {
      keys : {
        primary: '',
        secondary: '',
        startedOn: new Date()
      },
      showPrimary: false,
      showSecondary: false,
      loading: false
    }
  },
  computed: {
    primary() {
      return this.showPrimary ? this.keys.primary : ''.padEnd(this.keys.primary.length,'X');
    },
    secondary() {
      return this.showSecondary ? this.keys.secondary : ''.padEnd(this.keys.secondary.length,'X');
    },
    demoPortal() {
      return `${process.env.VUE_APP_DEMOPORTAL}${this.$store.state.token}`;
    }
  },
  created() {
    this.loading = true;
    this.$store.dispatch("userSubcriptionkeyGet", this.user).then(response => {            
      if(response.status === 200) {
        this.keys = response.data;
      }
      this.loading = false;
    }).catch(() => {
      this.loading = false;
    });
  },
}
</script>